import { AiScreen, createAiStore } from '@enter/core';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

/**
 * The provider app's AI page: the shared core screen with the store in its provider mode. A provider sees the profiles
 * its account is offered (read-only), issues, looks up and revokes its OWN keys, and tries the gateway; it cannot
 * change the account's AI configuration, list models or agents, or revoke keys in bulk.
 *
 * The store lives with the page, as the Roster's does: it is built when the page opens, and nothing else in the app
 * reads it. The screen clears it, plaintext keys included, when the page closes. Open to every user of the account.
 */
export const Ai = observer((): React.ReactElement => {
    const [store] = useState(() => createAiStore('provider'));
    return <AiScreen store={store} />;
});
